import React, { FC } from 'react'

import {
  Col,
  Grid,
  Line,
  Row,
  Span,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Text
} from 'components'
import { GrupoItenHht } from 'services/NGT/ReportsEffectives'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'
import FormatarNumeros from '../../../../../../utils/formatNumbers'

interface ITableSalaryReportSupplierProps {
  tableData: GrupoItenHht[]
}

const setJustifyIfHE = (justify: string, he: number) => {
  if (!justify || justify == '') return ''
  if (he && he.toString() != '0') return justify
  return ''
}

const TableSalaryReportSupplier: FC<ITableSalaryReportSupplierProps> = ({
  tableData
}) => {
  const subTotalIndex = tableData.map((data) => data.grupo).indexOf('SubTotal')
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="left">DE</TableCellStyled>
              <TableCellStyled align="left">DIR</TableCellStyled>
              <TableCellStyled align="left">GG</TableCellStyled>
              <TableCellStyled align="left">GER</TableCellStyled>
              <TableCellStyled align="left">Qtd. HHT</TableCellStyled>
              <TableCellStyled align="left">Qtd. HE</TableCellStyled>
              <TableCellStyled align="left">HE %</TableCellStyled>
              <TableCellStyled align="left">Justificativa HE%</TableCellStyled>
              <TableCellStyled align="left">Salario Base</TableCellStyled>
              <TableCellStyled align="left">Total Folha</TableCellStyled>
              <TableCellStyled align="left">
                <Col>
                  Total Efetivo
                  <Row justifyContent="center" alignItems="center">
                    <TableCellStyled align="center">
                      Com demitido
                    </TableCellStyled>
                    <TableCellStyled align="center">|</TableCellStyled>
                    <TableCellStyled align="center">
                      Sem Demitidos
                    </TableCellStyled>
                  </Row>
                </Col>
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map((row) => {
              return (
                !row.grupo && (
                  <TableRowStyled>
                    <TableCellStyled align="center">
                      {row?.cdContrato}
                    </TableCellStyled>
                    <TableCellStyled align="center">{row?.de}</TableCellStyled>
                    <TableCellStyled align="center">{row?.dir}</TableCellStyled>
                    <TableCellStyled align="center">{row?.gg}</TableCellStyled>
                    <TableCellStyled align="center">{row?.ger}</TableCellStyled>
                    <TableCellStyled align="center">
                      {formatarNumero(row?.qtdHht)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {formatarNumero(row?.qtdHe)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {formatarNumero(row?.percentHe)}
                    </TableCellStyled>
                    <Grid>
                      <TableCellStyled
                        style={{ backgroundColor: COLORS.headerColor }}
                        align="left"
                      >
                        Justificativa Nº Efetivos
                      </TableCellStyled>
                      <TableCellStyled
                        align="left"
                        style={{ height: 'auto', minHeight: '30px' }}
                      >
                        <div>{row.justificativaNumeroEfetivos ?? ''}</div>
                      </TableCellStyled>
                      <TableCellStyled
                        style={{ backgroundColor: COLORS.headerColor }}
                        align="left"
                      >
                        Justificativa %HE
                      </TableCellStyled>
                      <TableCellStyled
                        align="left"
                        style={{ height: 'auto', minHeight: '30px' }}
                      >
                        <div>{setJustifyIfHE(row?.justifQtdHe, row.qtdHe)}</div>
                      </TableCellStyled>
                      <TableCellStyled
                        style={{ backgroundColor: COLORS.headerColor }}
                        align="left"
                      >
                        Justificativa Vlr Contratada
                      </TableCellStyled>
                      <TableCellStyled
                        align="left"
                        style={{ height: 'auto', minHeight: '30px' }}
                      >
                        <div>{row.justificativaVlrContratada ?? ''}</div>
                      </TableCellStyled>
                    </Grid>
                    <TableCellStyled align="center">
                      {formatarNumero(row?.salBaseTotal)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {formatarNumero(row?.folhaPgtoTotal)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <Row justifyContent="center" alignItems="center">
                        <TableCellStyled align="center">
                          {formatarNumero(row?.qtTotalEfetivoComDemitido)}
                        </TableCellStyled>
                        <TableCellStyled align="center">
                          {formatarNumero(row?.qtTotalEfetivoSemDemitido)}
                        </TableCellStyled>
                      </Row>
                    </TableCellStyled>
                  </TableRowStyled>
                )
              )
            })}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <Line background={COLORS.blueFonts} />
      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Grid gridCols="1fr" gridGap="1rem" margin="1rem 0 0 0">
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="MÊS ANO ANTERIOR: "
            />
            <Span
              color={COLORS.blueFonts}
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text={tableData[subTotalIndex]?.mesAnoAnterior}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Salário Base: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[subTotalIndex]?.salBaseTotalAnterior
                ?.toLocaleString('pt-BR', {
                  currency: 'BRL',
                  style: 'currency'
                })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Folha: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[subTotalIndex]?.folhaPgtoTotalAnterior
                ?.toLocaleString('pt-BR', {
                  currency: 'BRL',
                  style: 'currency'
                })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total HHT: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[subTotalIndex].qtdHhtAnterior)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total HE: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[subTotalIndex].qtdHeAnterior)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total Efetivo: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(
                tableData[subTotalIndex].efetivoTotalAnterior
              )}
            />
          </Text>
          <Text></Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="% HHT x HE:"
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(
                tableData[subTotalIndex]?.percentHeHhtAnterior
              )}
            />
          </Text>
        </Grid>

        <Grid gridCols="1fr" gridGap="1rem" margin="1rem 0 0 0">
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="MÊS/ANO: "
            />
            <Span
              color={COLORS.blueFonts}
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text={tableData[subTotalIndex]?.mesAno}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Salário Base: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[subTotalIndex].salBaseTotal
                .toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total Folha: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={tableData[subTotalIndex].folhaPgtoTotal
                .toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
                .toString()}
            />
          </Text>
          <Text>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              fontWeight={FONTS.bold}
              text="Total HHT: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[subTotalIndex].qtdHht)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total HE: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[subTotalIndex].qtdHe)}
            />
          </Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="Total Efetivo: "
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(
                tableData[subTotalIndex].qtTotalEfetivoSemDemitido
              )}
            />
          </Text>
          <Text></Text>
          <Text>
            <Span
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              text="% HHT x HE:"
            />
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text={formatarNumero(tableData[subTotalIndex]?.percentHeHht)}
            />
          </Text>
        </Grid>
      </Grid>
    </>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero)
}

export default TableSalaryReportSupplier
